import {
  type ButtonHTMLAttributes,
  forwardRef,
  type PropsWithChildren,
} from 'react';

import { ScButton, type ScButtonProps } from './styled';

export const Button = forwardRef<
  HTMLButtonElement,
  PropsWithChildren & ButtonHTMLAttributes<HTMLButtonElement> & ScButtonProps
>(({ children, icon, ...props }, ref) => (
  <ScButton ref={ref} {...props} icon={icon}>
    <span>
      {children} {icon && icon}
    </span>
  </ScButton>
));
